import {
  UploadFile,
  DeleteFile,
  GetFileByID,
} from "../../DriveScout/API/models/FileModel";
import { saveToDisk } from "../../app/common/helpers/saveToDisk";

const state = {};

const mutations = {};

const actions = {
  UPLOAD_FILE({ commit, dispatch }, data) {
    return UploadFile(data.fileType, data.fileName, data.formData).then(
      (response) => {
        dispatch(
          "ui/ADD_FLASH_MESSAGE",
          { type: "success", message: response.data.message },
          { root: true },
        );
        return response.data.file;
      },
    );
  },
  DELETE_FILE({ commit, dispatch }, fileId) {
    return DeleteFile(fileId).then((response) => {
      dispatch(
        "ui/ADD_FLASH_MESSAGE",
        { type: "success", message: response.data.message },
        { root: true },
      );
      return response.data;
    });
  },
  GET_FILE({ commit }, fileId) {
    return GetFileByID(fileId).then((response) => {
      return response.data.file;
    });
  },
  DOWNLOAD_FILE({ commit, dispatch }, fileId) {
    GetFileByID(fileId)
      .then((response) => {
        dispatch(
          "ui/ADD_FLASH_MESSAGE",
          {
            type: "success",
            message: response.data.message,
          },
          { root: true },
        );
        saveToDisk(response.data.temporary_url);
      })
      .catch((error) => {
        // Handle error
      });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

